import { baseURL } from "../Config";
import axios from "axios";
import { toast } from "react-toastify";
import { loadingAction } from "../redux/actions/loadingAction";

export const handleAuthRequest =
    (data, url, isShowLoad = false, isShowToast = false) =>
        async (dispatch) => {
            try {
                if (isShowLoad) dispatch(loadingAction(true));
                const response = await axios({
                    method: "post",
                    url: `${baseURL + url}`,
                    data: data,
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: null,
                    },
                });
                if (isShowToast) toast.success(response?.data?.body || response?.data?.statusMessage || response?.data?.message);
                return response?.data;
            } catch (error) {
                if (error?.response?.status === 401) {
                    toast.warn(error?.response?.data?.message || error?.response?.data?.data?.message || "Invalid email or password");
                } else if (error?.response?.status === 400 || error?.response?.status === 500) {
                    toast.warn(error?.response?.data?.message || error?.response?.data?.data?.message || "Something went wrong !!");
                } else {
                    toast.warn(error?.response?.data?.message || error?.response?.data?.data?.message || "Something went wrong !!");
                }
                return error?.response?.data || error?.response || { statusCode: error?.response?.status || 500, message: "Login failed" };
            }
        };
